(function () {
	'use strict';

	angular
		.module('expo-cupom-digital')
		.controller('LoginController', LoginController)

	/** @ngInject */
	function LoginController($q, $state, UserService, HelperService, NotifyService, sweetAlert) {
		const vm = this;

		vm.submitLoginForm = () => {
			var loginData = angular.copy(vm.loginForm);

			if (!loginData || !loginData.email || !loginData.password) {
				NotifyService.error("Erro!", "Informe seu E-mail e senha para continuar!");
				return
			}

			loginData.password = Encrypt.Hash(loginData.password).toString();

			HelperService.startLoading(".content-body", "Fazendo login");

			UserService
				.login(loginData)
				.then(success => {
					HelperService.stopLoading(".content-body");

					if (success.errors) {
						HelperService.errorCallback(success);
						return
					}

					$state.go("app.home");
				}, error => {
					HelperService.stopLoading(".content-body");
					HelperService.errorCallback(error);
				})
		}

		vm.submitRegisterForm = () => {
			let user = angular.copy(vm.loginForm);

			if (!user || !user.email || !user.phone) {
				NotifyService.error("Erro!", "Informe seu E-mail e Celular nos campos acima para continuar!");
				return
			}

			let params = {
				email: user.email,
				phone: user.phone,
			}

			HelperService.startLoading(".content-body", "Enviando seus dados");

			UserService
				.verifyRegister(params)
				.then(success => {
					HelperService.stopLoading(".register")

					if (success.errors) {
						HelperService.errorCallback(success);
						return
					}

					saveUser(user);
				}, error => {
					HelperService.stopLoading(".register")
					HelperService.errorCallback(error)
				})
		}

		vm.loginWithFacebook = () => {
			let authUrl;

			HelperService.startLoading(".content-body", "Preparando login");

			UserService
				.getFacebookLoginUrl()
				.then(
					success => {
						if (success.LoginUrl) {
							authUrl = success.LoginUrl;
							window.location.href = authUrl;
						} else {
							NotifyService.notify({
								type: 'error',
								title: 'Ops!',
								text: 'Não foi possível realizar login com Facebook',
								confirmButtonText: 'Continuar',
								showCancelButton: false,
							})
						}

					}, error => {
						HelperService.stopLoading(".content-body");
						HelperService.errorCallback(error);
					});
		}

		vm.loginWithGoogle = () => {
			let authUrl;

			HelperService.startLoading(".content-body", "Preparando login");

			UserService
				.getGoogleLoginUrl()
				.then(
					success => {
						if (success.LoginUrl) {
							authUrl = success.LoginUrl;
							window.location.href = authUrl;
						} else {
							NotifyService.notify({
								type: 'error',
								title: 'Ops!',
								text: 'Não foi possível realizar login com Google',
								confirmButtonText: 'Continuar',
								showCancelButton: false,
							})
						}

					}, error => {
						HelperService.stopLoading(".content-body");
						HelperService.errorCallback(error);
					});
		}

		vm.showHidePwd = element => HelperService.showHidePwd(element);

		function saveUser(user) {
			UserService
				.post(user)
				.then(success => {
					HelperService.stopLoading(".content-body");

					if (success.errors) {
						HelperService.errorCallback(success);
						return
					}

					let config = {
						type: 'success',
						title: 'Parabéns!',
						text: 'Seu cadastro foi efetuado com sucesso!',
						confirmButtonText: 'Continuar',
						showCancelButton: false,
						allowOutsideClick: false,
						allowEscapeKey: false
					};

					NotifyService
						.notify(config, action => {
							if (action == true) {
								vm.submitLoginForm()
							}
						})

				}, error => {
					HelperService.stopLoading(".content-body");
					HelperService.errorCallback(error);
				})
		}



	}
}());